import problema01 from "./cartas/problema-01.webp";
import problema02 from "./cartas/problema-02.webp";
import problema03 from "./cartas/problema-03.webp";
import problema04 from "./cartas/problema-04.webp";
import problema05 from "./cartas/problema-05.webp";
import problema06 from "./cartas/problema-06.webp";
import problema07 from "./cartas/problema-07.webp";
import problema08 from "./cartas/problema-08.webp";
import problema09 from "./cartas/problema-09.webp";
import problema10 from "./cartas/problema-10.webp";
import raroAjuda from "./cartas/raro-ajuda.webp";
import raroAmeaca from "./cartas/raro-ameaca.webp";
import solucao01 from "./cartas/solucao-01.webp";
import solucao02 from "./cartas/solucao-02.webp";
import solucao03 from "./cartas/solucao-03.webp";
import solucao04 from "./cartas/solucao-04.webp";
import solucao05 from "./cartas/solucao-05.webp";
import solucao06 from "./cartas/solucao-06.webp";
import solucao07 from "./cartas/solucao-07.webp";
import solucao08 from "./cartas/solucao-08.webp";
import solucao09 from "./cartas/solucao-09.webp";
import solucao10 from "./cartas/solucao-10.webp";

// As 22 cartas do NORDESTE / Caatinga — o dado, separado do descritor.
//
// 20 comuns (10 problemas + 10 soluções, textos de MD/Cards_Curiosidade_Nordeste.md,
// arte real do ilustrador) e 2 raras, que formam o arco narrado pelo Tatu-bola.
//
// O NOME DO ARQUIVO É O ID, sem o prefixo da região (a pasta já é a região). Não é
// estética: `card_id` é a CHAVE da coleção do aluno em
// `activity_ludic_trail_collection` e não se renomeia depois de gravada, enquanto um
// slug descritivo ("desmatamento-carvao") pode envelhecer se o texto mudar de
// assunto. Com o id no nome do arquivo, os dois não têm como divergir — e o caminho
// da arte passa a ser DERIVÁVEL do id, o que apagou a convenção de nome que vivia
// duplicada em três lugares (o catálogo Python, ferramentas-diagnostico e aqui).
//
// Sem campo `fase`: a posição na trilha vem do sorteio, não é intrínseca ao card.

// Banco fixo de 20: o sorteio tira 4 por trilha sem repetir (ver
// ava/progressoDoAluno.js), e o tamanho do banco é o que dá chance de carta nova
// quando o aluno refaz.
export const CARDS_COMUNS_NORDESTE = [
  {
    id: "nordeste-problema-01",
    tipo: "problema",
    nome: "Desmatamento pra Carvão",
    asset: problema01,
    pilula:
      "Muitas árvores da Caatinga são cortadas pra virar carvão vegetal, usado pra cozinhar e gerar energia — e a floresta demora muito pra crescer de novo."
  },
  {
    id: "nordeste-problema-02",
    tipo: "problema",
    nome: "Queimadas",
    asset: problema02,
    pilula:
      'O fogo usado pra "limpar" terreno pra plantio às vezes foge de controle e queima áreas enormes de vegetação nativa.'
  },
  {
    id: "nordeste-problema-03",
    tipo: "problema",
    nome: "Gado Solto",
    asset: problema03,
    pilula:
      "Rebanhos soltos pisoteiam o solo e destroem as tocas rasas onde o tatu-bola costuma se enrolar e descansar."
  },
  {
    id: "nordeste-problema-04",
    tipo: "problema",
    nome: "Desertificação",
    asset: problema04,
    pilula:
      "Sem vegetação nativa, o chão vira um solo pobre e rachado — e o tatu-bola perde os insetos de que se alimenta."
  },
  {
    id: "nordeste-problema-05",
    tipo: "problema",
    nome: "Erosão do Solo",
    asset: problema05,
    pilula:
      "As chuvas fortes levam embora a terra fértil que sustenta as plantas e os bichinhos que o tatu-bola come."
  },
  {
    id: "nordeste-problema-06",
    tipo: "problema",
    nome: "Rios Secando",
    asset: problema06,
    pilula:
      "Com menos água disponível, fica mais difícil pro tatu-bola encontrar umidade e alimento na época mais seca do ano."
  },
  {
    id: "nordeste-problema-07",
    tipo: "problema",
    nome: "Extração sem Replantio",
    asset: problema07,
    pilula:
      "Cortar árvores como a aroeira sem plantar novas deixa a Caatinga cada vez mais aberta, sem abrigo pro tatu-bola."
  },
  {
    id: "nordeste-problema-08",
    tipo: "problema",
    nome: "Caça Ilegal",
    asset: problema08,
    pilula:
      "Por conseguir se fechar numa bola perfeita, o tatu-bola virou alvo fácil de caçadores — e sua população só diminui."
  },
  {
    id: "nordeste-problema-09",
    tipo: "problema",
    nome: "Monocultura",
    asset: problema09,
    pilula:
      "Grandes plantações de uma coisa só substituem a vegetação nativa onde o tatu-bola vivia, empurrando ele pra cada vez menos espaço."
  },
  {
    id: "nordeste-problema-10",
    tipo: "problema",
    nome: "Secas mais Longas",
    asset: problema10,
    pilula:
      "Secas mais compridas dificultam a Caatinga se recuperar, deixando o tatu-bola com menos comida e água por mais tempo."
  },
  {
    id: "nordeste-solucao-01",
    tipo: "solucao",
    nome: "Reflorestamento",
    asset: solucao01,
    pilula:
      "Plantar árvores nativas devolve ao tatu-bola os esconderijos e a comida que ele precisa pra sobreviver."
  },
  {
    id: "nordeste-solucao-02",
    tipo: "solucao",
    nome: "Manejo Sustentável",
    asset: solucao02,
    pilula:
      "Cortar madeira com planejamento e replantar sempre garante que a casa do tatu-bola continue de pé."
  },
  {
    id: "nordeste-solucao-03",
    tipo: "solucao",
    nome: "Aceiros e Fiscalização",
    asset: solucao03,
    pilula:
      "Impedir que queimadas se espalhem protege as tocas e os arbustos onde o tatu-bola se abriga."
  },
  {
    id: "nordeste-solucao-04",
    tipo: "solucao",
    nome: "Cisternas",
    asset: solucao04,
    pilula:
      "Guardar água da chuva pras famílias do sertão tira pressão dos rios e poços que o tatu-bola também depende."
  },
  {
    id: "nordeste-solucao-05",
    tipo: "solucao",
    nome: "Pastagem Rotativa",
    asset: solucao05,
    pilula:
      "Trocar o gado de área em área dá tempo pro solo e a vegetação nativa se recuperarem, sem destruir o habitat do tatu-bola."
  },
  {
    id: "nordeste-solucao-06",
    tipo: "solucao",
    nome: "Áreas Protegidas",
    asset: solucao06,
    pilula:
      "Territórios protegidos por lei viram um refúgio seguro onde o tatu-bola pode viver sem ameaças."
  },
  {
    id: "nordeste-solucao-07",
    tipo: "solucao",
    nome: "Combate ao Tráfico",
    asset: solucao07,
    pilula:
      "Fiscalizar e denunciar a caça ilegal é a forma mais direta de proteger o tatu-bola da extinção."
  },
  {
    id: "nordeste-solucao-08",
    tipo: "solucao",
    nome: "Agrofloresta",
    asset: solucao08,
    pilula:
      "Plantar misturando espécies nativas com a lavoura mantém corredores de vegetação por onde o tatu-bola pode circular."
  },
  {
    id: "nordeste-solucao-09",
    tipo: "solucao",
    nome: "Contar essa História",
    asset: solucao09,
    pilula:
      "Quanto mais gente conhece o tatu-bola e sua luta pra sobreviver, mais gente ajuda a protegê-lo — como você, agora!"
  },
  {
    id: "nordeste-solucao-10",
    tipo: "solucao",
    nome: "Proteger Nascentes",
    asset: solucao10,
    pilula:
      "Cuidar das margens de rios e riachos mantém a água disponível pro tatu-bola e pra toda a Caatinga."
  }
];

// Fora do sorteio: o arco do mascote, em 1ª pessoa. A ORDEM importa, e o casamento
// é ALINHADO PELO FIM (ver nucleo/recompensaDaFase.js) — numa trilha de 2 a 4 passos
// existe uma fase rara só, e ela tem de receber o FECHO. O último item é o único que
// todo aluno vê, e o único com `comemorar: true`.
export const CARDS_RAROS_NORDESTE = [
  {
    id: "nordeste-raro-ameaca",
    tipo: "raro",
    nome: "A Caatinga em Perigo",
    asset: raroAmeaca,
    pilula:
      "Ai, ai... meu lar está desaparecendo: derrubam árvores, ateiam fogo pro pasto, e ainda tem quem me caça. Continue a exploração pra me ajudar a preservar minha casinha!"
  },
  {
    id: "nordeste-raro-ajuda",
    tipo: "raro",
    nome: "Vamos Cuidar da Caatinga!",
    asset: raroAjuda,
    comemorar: true,
    pilula:
      "Graças a você, aprendi que não estou sozinho: cada árvore de pé e cada queimada evitada ajudam a proteger meu espaço. Continue de olho na natureza — cuidar do meu lar também é cuidar do seu!"
  }
];

export const CARDS_NORDESTE = [
  ...CARDS_COMUNS_NORDESTE,
  ...CARDS_RAROS_NORDESTE
];
